
import { useState, FormEvent } from 'react';

export default function ContactSection() {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    asunto: '',
    mensaje: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>(
    'idle'
  );

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formDataToSend = new URLSearchParams();
      formDataToSend.append('nombre', formData.nombre);
      formDataToSend.append('email', formData.email);
      formDataToSend.append('telefono', formData.telefono);
      formDataToSend.append('asunto', formData.asunto);
      formDataToSend.append('mensaje', formData.mensaje);

      const response = await fetch(
        '/contact.php',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: formDataToSend.toString(),
        }
      );

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nombre: '',
          email: '',
          telefono: '',
          asunto: '',
          mensaje: '',
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contacto" className="py-16 md:py-24 bg-[#0d1a2a]">
      <div className="max-w-7xl mx-auto px-5 md:px-6 lg:px-20">
        {/* Header */}
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-flex items-center gap-2 border border-[#B89A5A]/30 rounded-full px-4 md:px-5 py-2 mb-5 md:mb-6">
            <span className="text-[#B89A5A] text-xs md:text-sm font-medium tracking-wider">
              CONTACTO
            </span>
          </div>
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-serif font-bold text-white mb-3 md:mb-4">
            ¿Necesitas asesoramiento legal?
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-10">
          {/* Contact Form */}
          <div className="bg-[#14253D]/50 border border-white/8 rounded-[24px] md:rounded-[30px] p-6 md:p-8 lg:p-10">
            <h3 className="text-xl md:text-2xl font-serif font-bold text-white mb-5 md:mb-6">
              Envía tu consulta
            </h3>

            <form
              id="contact-form"
              onSubmit={handleSubmit}
              className="space-y-4 md:space-y-5"
            >
              <div>
                <label
                  htmlFor="nombre"
                  className="block text-xs md:text-sm font-medium text-white/70 mb-1.5 md:mb-2"
                >
                  Nombre completo *
                </label>
                <input
                  type="text"
                  id="nombre"
                  name="nombre"
                  required
                  value={formData.nombre}
                  onChange={(e) =>
                    setFormData({ ...formData, nombre: e.target.value })
                  }
                  className="w-full px-4 py-3 bg-white/5 border border-white/15 rounded-xl focus:outline-none focus:border-[#B89A5A] transition-colors text-white placeholder:text-white/30 text-sm"
                  placeholder="Tu nombre"
                />
              </div>

              <div>
                <label
                  htmlFor="email"
                  className="block text-xs md:text-sm font-medium text-white/70 mb-1.5 md:mb-2"
                >
                  Email *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                  className="w-full px-4 py-3 bg-white/5 border border-white/15 rounded-xl focus:outline-none focus:border-[#B89A5A] transition-colors text-white placeholder:text-white/30 text-sm"
                  placeholder="tu@email.com"
                />
              </div>

              <div>
                <label
                  htmlFor="telefono"
                  className="block text-xs md:text-sm font-medium text-white/70 mb-1.5 md:mb-2"
                >
                  Teléfono *
                </label>
                <input
                  type="tel"
                  id="telefono"
                  name="telefono"
                  required
                  value={formData.telefono}
                  onChange={(e) =>
                    setFormData({ ...formData, telefono: e.target.value })
                  }
                  className="w-full px-4 py-3 bg-white/5 border border-white/15 rounded-xl focus:outline-none focus:border-[#B89A5A] transition-colors text-white placeholder:text-white/30 text-sm"
                  placeholder="+54 351 123 4567"
                />
              </div>

              <div>
                <label
                  htmlFor="asunto"
                  className="block text-xs md:text-sm font-medium text-white/70 mb-1.5 md:mb-2"
                >
                  Asunto *
                </label>
                <select
                  id="asunto"
                  name="asunto"
                  required
                  value={formData.asunto}
                  onChange={(e) =>
                    setFormData({ ...formData, asunto: e.target.value })
                  }
                  className="w-full px-4 py-3 bg-white/5 border border-white/15 rounded-xl focus:outline-none focus:border-[#B89A5A] transition-colors text-white text-sm"
                >
                  <option value="" className="bg-[#14253D]">
                    Selecciona un área
                  </option>
                  <option value="Daños y Perjuicios" className="bg-[#14253D]">
                    Daños y Perjuicios
                  </option>
                  <option value="Derecho de Familia" className="bg-[#14253D]">
                    Derecho de Familia
                  </option>
                  <option value="Asuntos Civiles" className="bg-[#14253D]">
                    Asuntos Civiles
                  </option>
                  <option value="Otro" className="bg-[#14253D]">
                    Otro
                  </option>
                </select>
              </div>

              <div>
                <label
                  htmlFor="mensaje"
                  className="block text-xs md:text-sm font-medium text-white/70 mb-1.5 md:mb-2"
                >
                  Mensaje *
                </label>
                <textarea
                  id="mensaje"
                  name="mensaje"
                  required
                  rows={4}
                  maxLength={500}
                  value={formData.mensaje}
                  onChange={(e) =>
                    setFormData({ ...formData, mensaje: e.target.value })
                  }
                  className="w-full px-4 py-3 bg-white/5 border border-white/15 rounded-xl focus:outline-none focus:border-[#B89A5A] transition-colors text-white placeholder:text-white/30 resize-none text-sm"
                  placeholder="Describe brevemente tu consulta (máximo 500 caracteres)"
                ></textarea>
                <p className="text-xs text-white/40 mt-1">
                  {formData.mensaje.length}/500 caracteres
                </p>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-[#B89A5A] text-[#14253D] px-8 py-3.5 md:py-4 rounded-full text-sm md:text-base font-semibold hover:bg-[#A68A4A] transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {isSubmitting ? 'Enviando...' : 'Enviar Consulta'}
              </button>

              {submitStatus === 'success' && (
                <div className="bg-green-500/10 border border-green-500/30 text-green-400 px-4 py-3 rounded-xl text-sm">
                  ¡Mensaje enviado exitosamente! Te contactaremos pronto.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-500/10 border border-red-500/30 text-red-400 px-4 py-3 rounded-xl text-sm">
                  Hubo un error al enviar el mensaje. Por favor, intenta
                  nuevamente.
                </div>
              )}
            </form>
          </div>

          {/* Contact Info */}
          <div className="space-y-5 md:space-y-6">
            <div className="bg-[#14253D]/50 border border-white/8 rounded-[24px] md:rounded-[30px] p-6 md:p-8 lg:p-10 text-white">
              <h3 className="text-xl md:text-2xl font-serif font-bold mb-5 md:mb-6">
                Información de Contacto
              </h3>

              <div className="space-y-5 md:space-y-6">
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#B89A5A]/15 rounded-xl md:rounded-2xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-[#B89A5A] text-lg md:text-xl w-5 h-5 md:w-6 md:h-6 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <h4 className="font-bold mb-1 text-xs md:text-sm">Dirección</h4>
                    <a
                      href="https://www.google.com/maps/place/Jujuy+76,+X5022FMB+C%C3%B3rdoba/@-31.4131761,-64.1928992,17z/data=!3m1!4b1!4m6!3m5!1s0x9432987f5c9d56bb:0x2cddd95a7463515e!8m2!3d-31.4131807!4d-64.1903243!16s%2Fg%2F11vm144lb3?entry=ttu&g_ep=EgoyMDI2MDIwNC4wIKXMDSoASAFQAw%3D%3D"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white/65 hover:text-[#B89A5A] transition-colors cursor-pointer text-xs md:text-sm"
                    >
                      Jujuy 76 Oficina 3ºA<br />
                      Córdoba, Córdoba
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#B89A5A]/15 rounded-xl md:rounded-2xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-[#B89A5A] text-lg md:text-xl w-5 h-5 md:w-6 md:h-6 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <h4 className="font-bold mb-1 text-xs md:text-sm">Teléfono</h4>
                    <a
                      href="tel:+5493513495570"
                      className="text-white/65 hover:text-[#B89A5A] transition-colors cursor-pointer text-xs md:text-sm"
                    >
                      +54 351-3495570
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#B89A5A]/15 rounded-xl md:rounded-2xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-[#B89A5A] text-lg md:text-xl w-5 h-5 md:w-6 md:h-6 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <h4 className="font-bold mb-1 text-xs md:text-sm">Email</h4>
                    <a
                      href="mailto:abamigovalentina@gmail.com"
                      className="text-white/65 hover:text-[#B89A5A] transition-colors cursor-pointer break-all text-xs md:text-sm"
                    >
                      abamigovalentina@gmail.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#B89A5A]/15 rounded-xl md:rounded-2xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-[#B89A5A] text-lg md:text-xl w-5 h-5 md:w-6 md:h-6 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <h4 className="font-bold mb-1 text-xs md:text-sm">Horarios</h4>
                    <p className="text-white/65 text-xs md:text-sm">
                      Lunes a Viernes: 9:00 - 18:00<br />
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* WhatsApp CTA */}
            <div className="bg-[#B89A5A] rounded-[24px] md:rounded-[30px] p-6 md:p-8 lg:p-10 text-[#14253D]">
              <div className="flex items-center gap-3 md:gap-4 mb-3 md:mb-4">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-[#14253D]/15 rounded-xl md:rounded-2xl flex items-center justify-center">
                  <i className="ri-whatsapp-line text-xl md:text-2xl w-6 h-6 md:w-7 md:h-7 flex items-center justify-center"></i>
                </div>
                <h3 className="text-lg md:text-xl font-serif font-bold">Contacto Directo</h3>
              </div>
              <p className="mb-5 md:mb-6 text-[#14253D]/75 text-xs md:text-sm leading-relaxed">
                Para consultas legales, podés comunicarte directamente por
                WhatsApp. La atención es personalizada y confidencial.
              </p>
              <a
                href="https://wa.me/5493513495570?text=Hola,%20quisiera%20realizar%20una%20consulta%20legal."
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  if (typeof window !== 'undefined' && (window as any).gtag_report_conversion) {
                    (window as any).gtag_report_conversion('https://wa.me/5493513495570?text=Hola,%20quisiera%20realizar%20una%20consulta%20legal.');
                  }
                }}
                className="inline-block bg-[#14253D] text-white px-6 md:px-8 py-3.5 md:py-4 rounded-full text-sm md:text-base font-semibold hover:bg-[#1a2f4f] transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Contactar por WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
